// Modelo.js
import React, { useEffect, useState, Suspense } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import './Modelo.css';
import ModeloSpecs from '../components/Modelo/ModeloSpecs';
import ModeloTable from '../components/Modelo/ModeloTable';
import PageFooter from '../components/PageFooter';
import ModeloCatalogo from '../components/Modelo/ModeloCatalogo';
import ModeloHeaderWrapper from '../components/Modelo/ModeloHeaderWrapper'; // Importamos el wrapper

const Modelo = () => {
  const { modeloId } = useParams();
  const navigate = useNavigate();
  const [modelo, setModelo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchModelData = async () => {
      try {
        const response = await fetch(`https://cms.zoomlionlatam.com/api/modelos/${modeloId}?populate=serie,imagen_post,especificaciones`);
        const data = await response.json();

        if (!response.ok || !data.data) {
          throw new Error(`Error fetching model details for ID: ${modeloId}`);
        }

        const modeloData = data.data.attributes;
        modeloData.serie = data.data.attributes.serie?.data?.attributes?.nombre || "Serie desconocida";
        modeloData.imagenPostUrl = modeloData.imagen_post?.data?.attributes?.url || '/images/default-banner.webp';

        setModelo(modeloData);
      } catch (error) {
        console.error("Error fetching model data:", error);
        setError("Error loading model data.");
      } finally {
        setLoading(false);
      }
    };

    fetchModelData();
  }, [modeloId]);

  if (loading) {
    return (
      <div className="modelo-page-loading">
        <div className="spinner">Cargando...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="modelo-page-error">
        <h2>Ocurrió un error</h2>
        <p>{error}</p>
        <button onClick={() => navigate(-1)} className="modelo-page-button">
          Volver
        </button>
      </div>
    );
  }

  if (!modelo) {
    return <div>Error al cargar los detalles del modelo.</div>;
  }

  return (
    <>
      <div className="modelo-page-header">
        <ModeloHeaderWrapper
          nombre={modelo.nombre}
          serie={modelo.serie}
          descripcion={modelo.descripcion}
          imagenUrl={modelo.imagenPostUrl}
        />
      </div>

      <div className="modelo-page-container">
        <div className="modelo-page-detail">
          <ModeloSpecs specs={modelo.especificaciones} />
          <ModeloTable specs={modelo.especificaciones} />
        </div>
      </div>
      <ModeloCatalogo />
          <div className="modelo-page-buttons" >
            <button onClick={() => navigate('/contacto')} className="modelo-page-button">
              Solicitar cotización
            </button>
          </div>

      <div className="modelo-page-footer">
        <PageFooter />
      </div>
    </>
  );
};

export default Modelo;
